import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransunion = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1564 1571",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "logo (96)-svg" }),
		/* @__PURE__ */ _jsx("style", { children: "\n		.s0 { fill: currentColor } \n	" }),
		/* @__PURE__ */ _jsx("g", {
			id: "Layer",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Layer",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Layer",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Layer",
						className: "s0",
						d: "m1563.5 781.1c0 435-353.8 789.3-788.3 789.3-385.2 0-703.2-278-774.9-641.3l125.4-26.9c58.3 305 327 538.2 649.5 538.2 362.8 0 658.4-296 658.4-659.3 0-363.3-295.6-659.3-658.4-659.3-228.4 0-425.5 116.6-546.4 291.5v4.5c-35.9 62.8-49.3 116.6-35.9 143.5 13.5 22.4 40.3 35.9 85.1 35.9h143.4l67.2-210.8h134.3l-67.2 210.8h152.3l-40.3 130.1h-156.8l-49.2 152.4c-9 31.4-4.5 58.4 8.9 76.3 13.5 22.4 40.3 26.9 58.3 26.9 31.3 0 62.7-4.5 89.5-17.9 0 22.4 9 40.3 13.5 58.3 8.9 22.4 17.9 40.3 31.3 58.3-44.8 17.9-94 26.9-138.8 26.9-67.2 0-121-26.9-156.8-76.3-35.8-49.3-44.8-125.5-22.4-192.8l35.9-112.1h-98.6c-53.7 0-156.8-9-201.5-89.7-40.4-67.3-31.4-148 17.9-242.2 134.3-237.7 389.7-394.7 680.8-394.7 434.5 0 788.3 354.3 783.8 780.4z"
					})
				}), /* @__PURE__ */ _jsx("g", {
					id: "Layer",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Layer",
						className: "s0",
						d: "m1335.1 996.4c-4.5 4.4-4.5 13.4-9 17.9q-6.7 13.5-13.4 26.9-6.7 13.5-13.4 26.9-6.8 13.5-13.5 26.9c-4.5 4.5-4.5 9-8.9 13.5-4.5 0-22.4 4.5-35.9 4.5-31.3 0-58.2 0-103-13.5-31.3-13.4-53.7-31.4-71.7-58.3-53.7 44.9-120.9 71.8-183.6 71.8-67.2 0-116.4-26.9-152.3-71.8-35.8-49.3-44.8-116.6-22.4-179.4l85.1-260.1h134.4l-98.5 300.5c-13.5 31.4-4.5 49.3 4.4 62.8 9 17.9 31.4 22.4 49.3 22.4 62.7 0 134.4-53.8 156.8-121.1l85.1-260.1h134.3l-98.5 300.5c-4.5 13.4-4.5 26.9-4.5 35.8 4.5 22.5 17.9 31.4 26.9 40.4 26.9 17.9 67.2 22.4 98.5 22.4 22.4 0 40.4 0 53.8-8.9z"
					})
				})]
			})
		})
	]
});
export default SvgTransunion;
